import { styled, Box } from '../../../base';

export const StyledFunnelWrapper = styled(Box)({
    flex: 1,
});
